export const StudioActionTypes = {
  STUDIO_ACCOUNT_REQUEST: 'STUDIO_ACCOUNT_REQUEST',
  STUDIO_ACCOUNT_SUCCESS: 'STUDIO_ACCOUNT_SUCCESS',
  STUDIO_ACCOUNT_FAILURE: 'STUDIO_ACCOUNT_FAILURE',
  STUDIO_ACCOUNT_SET: 'STUDIO_ACCOUNT_SET',

  STUDIO_ACCESS_TRACKING_REQUEST: 'STUDIO_ACCESS_TRACKING_REQUEST',
  STUDIO_ACCESS_TRACKING_SUCCESS: 'STUDIO_ACCESS_TRACKING_SUCCESS',
  STUDIO_ACCESS_TRACKING_FAILURE: 'STUDIO_ACCESS_TRACKING_FAILURE',

  STUDIO_FORM_CHECK_REQUEST: 'STUDIO_FORM_CHECK_REQUEST',
  STUDIO_FORM_CHECK_SUCCESS: 'STUDIO_FORM_CHECK_SUCCESS',
  STUDIO_FORM_CHECK_FAILURE: 'STUDIO_FORM_CHECK_FAILURE',
  STUDIO_FORM_CHECK_SET: 'STUDIO_FORM_CHECK_SET',

  STUDIO_FORM_SEND_REQUEST: 'STUDIO_FORM_SEND_REQUEST',
  STUDIO_FORM_SEND_SUCCESS: 'STUDIO_FORM_SEND_SUCCESS',
  STUDIO_FORM_SEND_FAILURE: 'STUDIO_FORM_SEND_FAILURE',
  STUDIO_FORM_SEND_SET: 'STUDIO_FORM_SEND_SET',

  STUDIO_GET_TEMPLATES_FOR_ME: 'STUDIO_GET_TEMPLATES_FOR_ME',
  STUDIO_GET_TEMPLATES_FOR_ME_SUCCESS: 'STUDIO_GET_TEMPLATES_FOR_ME_SUCCESS',
  STUDIO_GET_TEMPLATES_FOR_ME_FAILURE: 'STUDIO_GET_TEMPLATES_FOR_ME_FAILURE',
  STUDIO_SET_TEMPLATES_FOR_ME: 'STUDIO_SET_TEMPLATES_FOR_ME',
  STUDIO_GET_TEMPLATES_FOR_ME_LOADING: 'STUDIO_GET_TEMPLATES_FOR_ME_LOADING',

  STUDIO_GET_TEMPLATES_REQUEST: 'STUDIO_GET_TEMPLATES_REQUEST',
  STUDIO_GET_TEMPLATES_SUCCESS: 'STUDIO_GET_TEMPLATES_SUCCESS',
  STUDIO_GET_TEMPLATES_FAILURE: 'STUDIO_GET_TEMPLATES_FAILURE',
  STUDIO_GET_TEMPLATES_SET: 'STUDIO_GET_TEMPLATES_SET',
  STUDIO_GET_TEMPLATES_LOADING: 'STUDIO_GET_TEMPLATES_LOADING',
  STUDIO_GET_TEMPLATES_RESET: 'STUDIO_GET_TEMPLATES_RESET',

  STUDIO_PRODUCTS_REQUEST: 'STUDIO_PRODUCTS_REQUEST',
  STUDIO_PRODUCTS_SUCCESS: 'STUDIO_PRODUCTS_SUCCESS',
  STUDIO_PRODUCTS_FAILURE: 'STUDIO_PRODUCTS_FAILURE',
  STUDIO_PRODUCTS_SET: 'STUDIO_PRODUCTS_SET',
  STUDIO_PRODUCTS_LOADING: 'STUDIO_PRODUCTS_LOADING',

  STUDIO_REQUEST_PROVISION_FREE_PLAN: 'STUDIO_REQUEST_PROVISION_FREE_PLAN',
  STUDIO_REQUEST_PROVISION_FREE_PLAN_SUCCESS: 'STUDIO_REQUEST_PROVISION_FREE_PLAN_SUCCESS',
  STUDIO_REQUEST_PROVISION_FREE_PLAN_FAILURE: 'STUDIO_REQUEST_PROVISION_FREE_PLAN_FAILURE',
  STUDIO_REQUEST_PROVISION_FREE_PLAN_LOADING: 'STUDIO_REQUEST_PROVISION_FREE_PLAN_LOADING',

  STUDIO_DOCUMENT_CREATION_REQUEST: 'STUDIO_DOCUMENT_CREATION_REQUEST',
  STUDIO_DOCUMENT_CREATION_SUCCESS: 'STUDIO_DOCUMENT_CREATION_SUCCESS',
  STUDIO_DOCUMENT_CREATION_FAILURE: 'STUDIO_DOCUMENT_CREATION_FAILURE',
  STUDIO_DOCUMENT_CREATION_LOADING: 'STUDIO_DOCUMENT_CREATION_LOADING',

  STUDIO_LOADING: 'STUDIO_LOADING',
};
